<template>
  <div class="form-group">
    <label v-if="label">{{ label }}<span v-if="helpText !== ''"><br><small>{{ helpText }}</small></span></label>

    <div class="input-group">
      <select :value="value" ref="inputField" :disabled="disabled" @change="updateValue" :class="['form-control', 'browser-default', hasErrors ? 'is-invalid' : '']">
        <option value="" v-if="showEmptyOption">{{ emptyOptionName }}</option>
        <option v-for="entry in entries" :key="entry.id" :value="entry.id">{{ entry[displayField] }}</option>
      </select>

      <div class="input-group-append" v-if="search">
        <e-button color="light" small class="m-0 text-black" @click="openModal" :disabled="disabled"><i class="fa fa-search" aria-hidden="true"></i></e-button>
      </div>

      <div class="invalid-feedback" v-if="hasErrors" v-html="errorMessage"></div>
    </div>

    <modal v-if="search && modalState" @close="modalState=false">
      <modal-header class="bg-primary text-light">
        <modal-title>Keresés</modal-title>
      </modal-header>

      <modal-body>
        <div>
          <e-text-input v-model="searchString" placeholder="Keresés..." />
        </div>

        <div>
          <div class="list-group" v-if="searchResult.length > 0">
            <button type="button" :class="['list-group-item', 'list-group-item-action', selectedEntryId === item.id ? 'active' : '']" v-for="item in searchResult" :key="item.id" @click="selectItem(item)">{{ item[displayField] }}</button>
          </div>

          <span v-else>Nincs találat</span>
        </div>
      </modal-body>

      <modal-footer>
        <e-button color="secondary" @click="modalState=false">Bezár</e-button>
        <e-button color="primary" @click="confirmSelection">Kiválaszt</e-button>
      </modal-footer>
    </modal>
  </div>
</template>

<script>
import { Modal, ModalHeader, ModalTitle, ModalBody, ModalFooter } from 'mdbvue'

export default {
  components: {
    Modal,
    ModalHeader,
    ModalTitle,
    ModalBody,
    ModalFooter
  },

  props: {
    value: {
      required: true
    },

    entries: {
      required: true
    },

    label: {
      type: String
    },

    helpText: {
      type: String,
      default: ''
    },

    readOnly: {
      type: Boolean,
      default: false
    },

    disabled: {
      type: Boolean,
      default: false
    },

    errors: {
      default: null
    },

    showEmptyOption: {
      type: Boolean,
      default: false
    },

    emptyOptionName: {
      type: String,
      default: 'Mind'
    },

    displayField: {
      type: String,
      default: 'name'
    },

    search: {
      type: Boolean,
      default: false
    }
  },

  data () {
    return {
      modalState: false,
      searchString: '',
      selectedEntryId: null
    }
  },

  computed: {
    hasErrors () {
      return this.errors !== null && this.errors.length > 0
    },

    errorMessage () {
      return this.errors.join('<br>')
    },

    searchResult () {
      return this.entries.filter(e => e[this.displayField].toLowerCase().startsWith(this.searchString)).slice(0, 5)
    }
  },

  methods: {
    updateValue (event) {
      this.$emit('input', this.$refs.inputField.value)
    },

    openModal () {
      this.searchString = ''
      this.selectedEntryId = null
      this.modalState = true
    },

    selectItem (item) {
      this.selectedEntryId = item.id
    },

    confirmSelection () {
      this.$emit('selectItem', this.entries.find(e => e.id === this.selectedEntryId))
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/plugins/formFields/eSelect.vue